export const countJulyoOccupyingSeats = (args) => {
    const { adults, children, seniors = 0 } = args;
    return adults + children + seniors;
};
export const resolveCatalogProductAvailableSeats = (product) => {
    const legs = product.legs ?? [];
    const segmentSeats = legs.flatMap((leg) => {
        return (leg.segments ?? [])
            .map((segment) => {
            return segment.availableSeats;
        })
            .filter((value) => {
            return value != null;
        });
    });
    if (segmentSeats.length > 0) {
        return Math.min(...segmentSeats);
    }
    const productSeats = product.availableSeats;
    return typeof productSeats === 'number' && productSeats > 0 ? productSeats : 0;
};
export const resolveShowResourceLevel = (product) => {
    return product.resourceLevel ?? 0;
};
export const isCatalogProductSellableForOccupyingSeats = (product, occupyingSeats) => {
    if (occupyingSeats <= 0) {
        return resolveCatalogProductAvailableSeats(product) > 0;
    }
    return resolveCatalogProductAvailableSeats(product) >= occupyingSeats;
};
//# sourceMappingURL=julyo-catalog-seats.js.map